import React from 'react';
import {Field} from 'react-final-form';

const FieldError = ({name}) => (
  <Field
    name={name}
    subscribe={{modified: true, invalid: true, error: true, submitError: true}}
    render={({meta: {modified, invalid, error, submitError}}) =>
      modified && invalid ? <small className="form-text text-danger">{error || submitError}</small> : null
    }
  />
);

export default FieldError;
